import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveCostProfileFromResourceRequestFailure(resource) {
      const req = getState().find((req) => req.resource.uuid === resource.uuid);

      return req ? req.request.isFailure : false;
    },
    isRemoveCostProfileFromResourceRequestPending(resource) {
      const req = getState().find((req) => req.resource.uuid === resource.uuid);

      return req ? req.request.isPending : false;
    },
    isRemoveCostProfileFromResourceRequestSuccess(resource) {
      const req = getState().find((req) => req.resource.uuid === resource.uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
